import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BoysProfiles = () => {
  const [boysProfiles, setBoysProfiles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://shubhjiwan.co.in/ShubhJiwan_backend11/fetch_boys_profiles.php")
      .then((response) => response.json())
      .then((data) => {
        setBoysProfiles(data);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const handleViewProfile = (id) => {
    const isLoggedIn = localStorage.getItem("token");
    if (isLoggedIn) {
      navigate(`/profileDetails/${id}`);
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="bg-gray-100 py-10 flex justify-center">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-3xl uppercase font-semibold text-center text-[#0069a7] mb-12">
          Featured Boys Profiles
        </h1>

        {boysProfiles.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {boysProfiles.map((profile) => (
              <div
                key={profile.id}
                className="bg-white shadow-md rounded-lg overflow-hidden transform hover:scale-105 hover:shadow-lg transition-all duration-300"
              >
                <div className="relative group">
                  <img
                    src={profile.photo ? profile.photo : "/images/default-profile.jpg"}
                    alt={profile.name}
                    className="w-full h-80 object-cover"
                  />
                </div>

                <div className="p-6 text-center">
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    {profile.name}
                  </h2>

                  <div className="mt-4">
                    <button
                      onClick={() => handleViewProfile(profile.id)}
                      className="w-full bg-[#0069a7] text-white py-2 rounded-md text-sm font-medium uppercase hover:bg-violet-600 transition-all duration-300"
                    >
                      View Profile
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-600 mt-6">No male profiles available.</p>
        )}
      </div>
    </div>
  );
};

export default BoysProfiles;
